import styled from 'styled-components';

export const TableRoot = styled.div`
  margin: ${({ theme }) => theme.spacing(1, 0, 0)};
`;
